import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

export default angular.module('cms.page.class', [uiRouter])
    .directive('cmsPageClass', function ($state) {
        /** @ngInclude() */
        return {
            link: function (scope) {

              scope.$stateClass = () => {
                return 'cms-state-' + ($state.current.name || 'undefined');
              }

            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/cmsCore/PageClass/PageClassDirective.js